import { useEffect, useState } from "react";
import Address from "./Address";
import { useTranslation } from "react-i18next";
import { getAddresses } from "../../../services/userService";
import { useCookies } from "react-cookie";

export default function Addresses({
  showDeletedMessage,
  setShowDeletedMessage,
}) {
  const { t } = useTranslation();
  const [addresses, setAddresses] = useState([]);
  const [cookie] = useCookies(["access_token"]);
  const [newAddresses, setNewAddresses] = useState([]);

  const handleAddNewAddress = () => {
    setNewAddresses([...newAddresses, { count: newAddresses.length + 1 }]);
  };;

  useEffect(() => {
    getAddresses(cookie.access_token).then((res) => {
      setAddresses(res);
    });
  }, []);

  return (
    <>
      <div className="addresses">
        <div className="add-new">
          <button onClick={handleAddNewAddress}>{t("add-new")}</button>
        </div>
        {newAddresses.map((address, index) => (
          <Address key={index} newAddress={true} address={address} />
        ))}
        {addresses?.map((address) => {
          return (
            <Address
              newAddress={false}
              address={address}
              showDeletedMessage={showDeletedMessage}
              setShowDeletedMessage={setShowDeletedMessage}
            ></Address>
          );
        })}
      </div>
    </>
  );
}
